import React  from 'react';

import MobileStoreButton, { EStoreName } from '@r1-frontend/ui-react/components/buttons/mobileStoreButton';
import { H4, H5 } from '@r1-frontend/ui-react/components/typography/heading';
import { ITheme, TSendRequestHandle } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/types';
import { Copyright } from '@r1-frontend/ui-react/organisms/Footer/components/Copyright';
import { FooterLinks } from '@r1-frontend/ui-react/organisms/Footer/components/FooterLinks';
import { dzen, maxIcon, odnoklassniki, telegram, vkontakte } from '@r1-frontend/ui-react/organisms/Footer/components/icons/icons';
import { PayButton } from '@r1-frontend/ui-react/organisms/Footer/components/PayButton';
import { Support } from '@r1-frontend/ui-react/organisms/Footer/components/Support';

import * as ST from './styled';

interface ILink {
    text: string,
    link: string,
}

interface IServicesLinkInfo {
    title: string,
    key: string,
    linkList: ILink[],
}

export interface IFooterLinks {
    payButtonLink?: string,
    requestLink?: string,
    policyLink?: string,
    copyrightLink: string,
    cobrandLegalEntity?: string,
    cobrandCopyrightLink?: string,
}

interface IFooter {
    phone: string,
    onClickMobileButton: (mobileOs: string, e: React.SyntheticEvent<HTMLDivElement>) => void,
    servicesLinks: {
        services: ILink[],
        info: IServicesLinkInfo[],
    },
    sendRequestHandle: TSendRequestHandle,
    onChangeHandle: (theme: ITheme) => void,
    openChatHandler: () => void,
    text?: string,
    withChat?: boolean,
    contactEmail?: string,
    links: IFooterLinks,
}

const SOCIALS = [
    { link: 'https://vk.com/domru', background: 'white', img: vkontakte },
    { link: 'https://ok.ru/domru', background: 'white', img: odnoklassniki },
    { link: 'https://t.me/domru_official', background: 'white', img: telegram },
    { link: 'https://max.ru/domru_official', background: 'white', img: maxIcon },
    { link: 'https://dzen.ru/domru', background: 'white', img: dzen },
];

export const Footer = ({
    onChangeHandle,
    onClickMobileButton,
    openChatHandler,
    links,
    contactEmail,
    phone,
    text,
    servicesLinks,
    sendRequestHandle,
    withChat,
}: IFooter) => (
    <ST.Footer data-test='footer'>
        <ST.Wrap>
            <ST.FooterTop>
                <ST.FooterSupport>
                    <ST.Container>
                        <Support
                            withChat={withChat}
                            contactEmail={contactEmail}
                            phone={phone}
                            requestLink={links?.requestLink}
                            policyLink={links?.policyLink}
                            openChatHandler={openChatHandler}
                            sendRequestHandle={sendRequestHandle}
                            onChangeHandle={onChangeHandle}
                            data-test='support'
                        />
                        <ST.SocialContainer>
                            <ST.SocialText>Мы в соц. сетях</ST.SocialText>
                            <ST.SocialStyled data-test='social' socials={SOCIALS}/>
                        </ST.SocialContainer>
                    </ST.Container>
                    <ST.StoreButtons>
                        <MobileStoreButton
                            onClick={(e: React.SyntheticEvent<HTMLDivElement>) => onClickMobileButton('Android', e)}
                            store={EStoreName.GooglePlay}
                            data-test='google-play'
                        />
                    </ST.StoreButtons>
                </ST.FooterSupport>

                <ST.FooterService>
                    <ST.LinksWrap>
                        <FooterLinks
                            links={servicesLinks.services}
                            title={'Услуги'}
                            data-test={'links-service'}
                        />
                        {servicesLinks.info.map(({ title, linkList, key }) => (
                            <FooterLinks
                                title={title}
                                links={linkList}
                                key={key}
                                data-test={key}
                            />
                        ))}
                    </ST.LinksWrap>
                    <ST.Store>
                        <PayButton data-test='payment-btn' payButtonLink={links?.payButtonLink}/>
                        <ST.LogoContainer>
                            <ST.LogoText>
                                <H4 $withIndent={false} $color={'TextHint'} $smaller>19 лет с вами</H4>
                                <H5 $withIndent={false} $color={'TextHint'}>Спасибо, что доверяете нам каждый день</H5>
                            </ST.LogoText>
                            <ST.LogoImage>
                                <img src='https://cdn-b2c.dom.ru/b2c-domru/stable/frontend/static/images/logo-original.png' alt='Логотип дом.ru'/>
                            </ST.LogoImage>
                        </ST.LogoContainer>
                    </ST.Store>
                </ST.FooterService>
            </ST.FooterTop>

            <ST.FooterBottom>
                <Copyright
                    data-test='policy'
                    copyrightLink={links.copyrightLink}
                    cobrandLegalEntity={links?.cobrandLegalEntity}
                    cobrandCopyrightLink={links?.cobrandCopyrightLink}
                />
                {text && <ST.FooterText>{text}</ST.FooterText>}
            </ST.FooterBottom>
        </ST.Wrap>
    </ST.Footer>
);
